import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../spinner/spinner.service';
import { CurrentUser } from '../../shared-module/common/services/current-user.service';
import { environment } from '../../../environments/environment';
import { HeaderService } from './header.service';
import { ActivatedRoute } from '@angular/router';
import { TenantSettings } from '../../shared-module/common/services/tenant-settings.service';
import { JouleService } from '../../shared-module/common/services/joule.service';
import SdkHelpers from '../../shared-module/cpq-built-in-support/cpq-get-SDK';
import { FooterService } from '../footer/footer.service';
import { loadScript, loadStyle } from '../../shared-module/cpq-built-in-support/cpq-load-script';

@Component({
    selector: 'setup-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
    providers: [FooterService],
})
export class HeaderComponent implements OnInit {
  public currentHelpLink: string;
  public exitSetupLink: string;
  public logOutLink: string;
  public currentPage: string;
  public show = false;
  public customerInitials: string;
  public productVersion: string;

  constructor(public spinnerService: SpinnerService,
    public user: CurrentUser,
    private headerService: HeaderService,
    public route: ActivatedRoute,
    public tenantSettings: TenantSettings,
    public jouleService: JouleService,
    public footerService: FooterService) { }

  ngOnInit() {
    this.headerService.urlChanged.subscribe((helpLink: string) => {
      this.currentHelpLink = helpLink;
    });
    this.headerService.titleChanged.subscribe((currentPage: string) => {
      this.currentPage = currentPage;
    });
    this.footerService.getCpqVersion().subscribe(cpqVersion => {
      this.productVersion =  cpqVersion;
    });

    this.exitSetupLink = `${window.location.origin}/exitsetup.aspx`;
    this.logOutLink = `${window.location.origin}/logoff.aspx?admin=1`;
  }

  public closeCustomerMenu(event) {
    event.stopPropagation();
    this.show = false;
  }

  public toggleCustomerMenu() {
    this.show = !this.show;
  }

  public toggleJoule(event: Event): void {
    event.preventDefault();
    this.jouleService.toggle();
  }

  public openDSX = async (event: Event): Promise<void> => {
    event.preventDefault();
    let sdk = SdkHelpers.getSDK();
    if (!sdk) {
      await loadStyle(this.tenantSettings.builtInSupportCSSURLPath);
      const result = await loadScript(this.tenantSettings.builtInSupportURLPath);
      sdk = result.sdk;
    
      SdkHelpers.setSDK(sdk);
    }
    if (sdk) {
      if (!sdk.isInitialized()) {
        console.log('open DSX first time')
        sdk.create({
          version: 'V1',
          targetEnvironment: this.tenantSettings.builtInSupportTargetEnvironment,
          useIcon: false,
          zIndex: 1000,
          getProductContext: ()=> {
            return  new Promise((resolve)=> {
                resolve({
                    productVersion: this.productVersion,
                    systemRole: 'CPQ',
                    tenantID: this.tenantSettings.tenantID,
                    systemURL: this.tenantSettings.tenantUrl,
                    PPMSIDs: ['73555000100800001601'],
                    productFallbackACH: 'CEC-SAL-CPQ',
                    productSupportACH: 'CEC-SAL-CPQ'
                })
            })
          },
          getRecommendedLinks: function () {
            return new Promise((resolve)=> {
              resolve({
                recommendedLinks: [{
                  text: "SAP Help Portal",
                  url: "https://help.sap.com/docs/SAP_CPQ"
                }]
              })
            })
          },
          getApplicationContext: function () {
            return  new Promise((resolve)=> {
            resolve({
                applicationName: 'CPQ',
                achComponent: 'CEC-SAL-CPQ'
              })
            })
          }
        })
        sdk.openWindow()
      } else {
        console.log('open DSX second time')
        sdk.openWindow()

      }
    }
  }
}
